import React, { useState } from 'react';

export default function WhatsAppBtn() {
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <style>{`
        @keyframes waPulse {
          0%, 100% { box-shadow: 0 6px 24px rgba(37,211,102,0.4); }
          50%       { box-shadow: 0 6px 32px rgba(37,211,102,0.65); }
        }
      `}</style>
      <a
        href="https://wa.me/447853481188"
        target="_blank"
        rel="noreferrer"
        title="Chat on WhatsApp"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          position: 'fixed', bottom: 28, right: 28, zIndex: 300,
          width: 58, height: 58,
          background: '#25d366',
          borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 28, textDecoration: 'none',
          animation: 'waPulse 2.5s infinite',
          transform: hovered ? 'scale(1.12)' : 'scale(1)',
          transition: 'transform 0.2s',
          boxShadow: hovered ? '0 8px 30px rgba(37,211,102,0.55)' : undefined,
        }}>
        💬
      </a>
    </>
  );
}
